/**
 * Ensure a dom element in defined and is type of HTMLElement
 */
export function ensureHTMLElement(element: Element | null): HTMLElement {
  if (!element || !(element instanceof HTMLElement)) {
    throw new Error("Not an HTMLElement");
  }
  return element;
}

/**
 * Ensure all dom elements in a NodeList are HTMLElements
 */
export function ensureHTMLNodeList(elements: NodeListOf<Element>): NodeListOf<HTMLElement> {
  if (!Array.from(elements).every((el) => el instanceof HTMLElement)) {
    throw new Error("Not a list of HTMLElement");
  }
  return elements as NodeListOf<HTMLElement>;
}

export const ensureProps = <T, K extends keyof T>(
  obj: T,
  ...keys: K[]
): obj is T & { [P in K]-?: NonNullable<T[P]> } => keys.every((k) => obj[k] != null);
